import { parseToRgba } from 'color2k';

export const hexToVTKColor = (color: string): [number, number, number] => {
  const rgb = parseToRgba(color);
  return [rgb[0] / 255, rgb[1] / 255, rgb[2] / 255];
};
